PluginButtonView = require 'app/scripts/views/plugin/plugin-button-view'
t = require('app/scripts/views/internal/teacup-with-helpers')()
{ IconDefaultColor } = require '@trello/nachos'
{ track, trackUe } = require '@trello/analytics'
{ sendPluginUIEvent } = require 'app/scripts/lib/plugins/plugin-behavioral-analytics'

template = t.renderable ({ icon, text, monochrome }) ->
  t.a '.button-link', {
    title: text,
    href: '#'
  }, ->
    if icon
      t.span
        class: t.classify({ 'icon-sm': true, 'plugin-icon': true, 'mod-reset': monochrome == false })
        style: t.stylify
          'background-image': t.urlify t.addRecolorParam(icon, "?color=#{ IconDefaultColor.substr(1).toLowerCase() }")
    t.span text

module.exports = class PluginCardButtonView extends PluginButtonView

  render: ->
    @$el.html(template(@pluginButton))
    @

  trackClick: (pluginButton) ->
    track("Card Detail", "Sidebar Plugin Button", pluginButton.text)
    trackUe('card detail', 'opens', 'Power-Up', '', '', 'card-button', pluginButton.idPlugin)
    sendPluginUIEvent(pluginButton.idPlugin, {
      action: 'clicked'
      actionSubject: 'button'
      source: 'cardDetailScreen'
      actionSubjectId: 'cardButton'
      objectType: 'powerUp'
      objectId: pluginButton.idPlugin
    })
